
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 25179"}},[_c('path',{attrs:{"data-name":"Path 28834","d":"M6.5.004l1.292 1.678L9.75.875l.28 2.1 2.1.28-.807 1.958 1.678 1.292-1.678 1.292.807 1.958-2.1.28-.28 2.1-1.958-.807L6.5 13.006l-1.292-1.678-1.958.807-.28-2.1-2.1-.28.807-1.958-1.678-1.292 1.678-1.292L.87 3.255l2.1-.28.28-2.1 1.958.807z","fill":"#666"}}),_c('g',{attrs:{"data-name":"Group 25125"}},[_c('path',{attrs:{"data-name":"Path 28815","d":"M4.166 6.388l1.233 1.234 3.3-3.478.585.526-3.851 4.094-1.819-1.819.557-.557z","fill":"#fff","stroke":"#fff","stroke-linecap":"round","stroke-width":".5"}})])])])
          )
        }
      }
    